// import http from '@/utils/http';
import http from '@/utils/httpAxios'
// import questionnaireApi from '@/api/questionnaire';
// import bulletinApi from '@/api/bulletin';
// import communicationApi from '@api/communication';

import { Toast } from 'vant';
const $ = window.Zepto;

function objToQueryStr(obj) {
  if (typeof obj != 'object') return '';
  let queryStr = '?';
  for (let key in obj) {
    queryStr += key + '=' + obj[key] + '&';
  }
  return queryStr.slice(0, -1);
}

module.exports = {
  // /phoenix/arctic/v1/wx/viewOpenId
  // 获取openid
  apiGetOpenId(code) {
    return http
      .get('/phoenix/phoenix/arctic/v1/wx/viewOpenId', { code,weChatOfficialAccountType: localStorage.getItem('weChatOfficialAccountType') || ''})

      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // openid获取用户信息
  apiGetUserInfo(openId) {
    return http
      .get(
        `/phoenix/phoenix/arctic/v1/merchant/individual/viewByOpenId?openId=${openId}&weChatOfficialAccountType=${localStorage.getItem('weChatOfficialAccountType') || ''}`
      )
      .then(res => {
        // if (res.status === 200) {
        //   return res.data;
        // } else {
        //   throw res;
        // }
        return res
      });
  },

  // app端获取商户信息
  apiGetAppUserInfo(mobile) {
    return http
      .get(
        `/phoenix/phoenix/arctic/v1/merchant/seal/viewTraderInfo?mobile=${mobile}`
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // app端获取商户信息
  apiGetInfo_userId(userId) {
    return http
      .get(
        `/phoenix/phoenix/arctic/v1/merchant/individual/viewByUserId?userId=${userId}`
      )
      .then(res => {
        return res
        // if (res.status === 200) {
        //   return res.data;
        // } else {
        //   throw res;
        // }
      });
  },

  // 获取验证码
  apiGetVerifyCode(mobile) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post(
        '/phoenix/phoenix/arctic/v1/user/verify',
        JSON.stringify({ mobile, msgType: 0 }),
        headers
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          Toast({
            message: res.message,
            forbidClick: true,
            duration: 5000,
          });
          throw res;
        }
      });
  },

  // 手机、验证码登录
  apiGetUserLogin(data) {
    let body = {
      ...data,
      weChatOfficialAccountType: localStorage.getItem('weChatOfficialAccountType') || ''
    }
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    return http
      .post(
        '/phoenix/phoenix/arctic/v1/user/paymentLogin',
        JSON.stringify(body),
        headers
      )
      .then(res => {
        // if (res.status === 200) {
        //   return res.data;
        // } else {
        //   throw res;
        // }
        return res
      });
  },

  // 识别银行卡

  apiGetBankCardInfo(form) {
    const config = {
      // 'Content-Type': 'multipart/form-data',
      processData: false,
      mimeType: 'multipart/form-data',
      contentType: false,
    };
    Toast.loading({
      message: '银行卡识别中...',
      forbidClick: true,
      duration: 0,
    });
    return http
      .post(
        '/phoenix/phoenix/arctic/v1/merchant/individual/identifyBankCard',
        form,
        {},
        config
      )
      .then(res => {
        let result = JSON.parse(res);
        if (result.status === 200 && result.data) {
          Toast.success('识别成功');
          return result.data;
        } else {
          Toast.fail('识别失败');
          throw result;
        }
      });
  },

  // 联行号列表
  apiGetBankList(bankName) {
    return new Promise((rs, rj) => {
      $.ajax({
        type: 'GET',
        url: 'https://wicmp.wandawic.com/api/bill/bill/v1/inter/bankNoForName',
        data: { bankName },
        success(res) {
          rs(res);
        },
        error(err) {
          rj(err);
        },
      });
    });
  },

  // 用户注册
  apiPostUserRegist(form) {
    const config = {
      processData: false,
      mimeType: 'multipart/form-data',
      contentType: false,
    };
    // let data = {
    //   ...form,
    //   openId: getOpenId(),
    // };
    return http
      .post(
        '/phoenix/phoenix/arctic/v1/merchant/individual/create-individual',
        form,
        {},
        config
      )
      .then(res => {
        return res;
        // if (res.status === 200) {
        //   return res.data;
        // } else {
        //   throw res;
        // }
      });
  },

  // 获取广场

  apiGetPlaza(data) {
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-plaza',
        data
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 获取品牌

  ApiGetBrand(data) {
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-brand',
        data
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 合同列表
  /*
  interface = {
    brandId:string,   品牌id
    contractState:number,    合同状态
    contractType:string,    合同类型
    phone:string,     商户手机号
    plazaId:number,     广场id
    token
  }
  */

  apiGetAgreementList(data) {
    if (data.contractId) {
      return http
        .get('/phoenix/phoenix/arctic/v1/merchant/electronic-contract/view', {
          contractId: data.contractId,
        })
        .then(res => {
          if (res.status === 200) {
            return [res.data];
          } else {
            throw res;
          }
        });
    } else {
      return http
        .get(
          '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views',
          data
        )
        .then(res => {
          if (res.status === 200) {
            return res.data;
          } else {
            throw res;
          }
        });
    }
  },

  // 获取合同pdf
  // /phoenix/arctic/v1/merchant/electronic-contract/downLoad
  apiGetContractFile(contractUrl) {
    return http
      .get('/phoenix/phoenix/arctic/v1/merchant/electronic-contract/downLoad', {
        key: contractUrl,
      })
      .then(res => {
        return res;
      });
  },
  // 企业电签-管理员信息
  ApiGetSealUser(data) {
    return http
      .get('/phoenix/phoenix/arctic/v1/merchant/seal/view-seal-user', data)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // /phoenix/arctic/v1/merchant/seal/view-cert-status
  // 查看证书状态
  ApiGetSealStatus(data) {
    return http
      .get('/phoenix/phoenix/arctic/v1/merchant/seal/view-cert-status', data)
      .then(res => {
        if (res.status === 200) {
          return res;
        } else {
          throw res;
        }
      });
  },

  // 修改印章保管员
  apiEditSealKeeper(data) {
    // let arr = []
    // for (const key in data) {
    //   arr.push(`${key}=${data[key]}`)
    // }
    // let requestStr = arr.join('&')
    return http
      .post(
        `/phoenix/phoenix/arctic/v1/merchant/seal/alter-seal-keeper?email=${data.email}&idNo=${data.idNo}&mobile=${data.mobile}&name=${data.name}&traderId=${data.traderId}`
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 查看多个合同-企业电签
  ApiGetViewsSeal(data) {
    // return http
    //   .get('/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-seal', data)
    //   .then(res => {
    //     if (res.status === 200) {
    //       return res.data
    //     } else {
    //       throw res;
    //     }
    //   });

    if (data.contractId) {
      return http
        .get('/phoenix/phoenix/arctic/v1/merchant/electronic-contract/view', {
          contractId: data.contractId,
        })
        .then(res => {
          if (res.status === 200) {
            return [res.data];
          } else {
            throw res;
          }
        });
    } else {
      return http
        .get('/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-seal', data)
        .then(res => {
          if (res.status === 200) {
            return res.data;
          } else {
            throw res;
          }
        });
    }
  },
  // 查看广场信息-企业电签
  ApiGetViewsPlazaSeal(data) {
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-plaza-seal',
        data
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 查看品牌信息-企业电签
  ApiGetViewsBrandSeal(data) {
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/views-brand-seal',
        data
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 生成电签url
  ApiGetCompanySignUrl(data) {
    let url = objToQueryStr(data);
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/view/sign-url' +
          url
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 生成云证书url
  ApiGetCloudCertUrl(data) {
    let url = objToQueryStr(data);
    return http
      .get(
        '/phoenix/phoenix/arctic/v1/merchant/electronic-contract/view/cloud-cert-url' +
          url
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};
